var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMarkDialog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.4545,
    height: 17.4545,
    viewBox: "0 0 17.4545 17.4545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M3.97794 3.97794C4.19095 3.76493 4.53632 3.76493 4.74933 3.97794L8.72727 7.95588L12.7052 3.97794C12.9182 3.76493 13.2636 3.76493 13.4766 3.97794C13.6896 4.19096 13.6896 4.53632 13.4766 4.74933L9.49866 8.72727L13.4766 12.7052C13.6896 12.9182 13.6896 13.2636 13.4766 13.4766C13.2636 13.6896 12.9182 13.6896 12.7052 13.4766L8.72727 9.49866L4.74933 13.4766C4.53632 13.6896 4.19095 13.6896 3.97794 13.4766C3.76493 13.2636 3.76493 12.9182 3.97794 12.7052L7.95588 8.72727L3.97794 4.74933C3.76493 4.53632 3.76493 4.19095 3.97794 3.97794Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4A304A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkDialog);
export default __webpack_public_path__ + "static/media/x-mark-dialog.b045b91e44b3b656c3c811a9b9050c7b.svg";
export { ForwardRef as ReactComponent };